<template>
    <div class="carousel">
        <div class="index-carousel" ref="carousel">
            <transition name="fade" mode="out-in">
                <div key="Zh" v-if="!isEn" class="box" :class="{boxEn:isEn}">
                   <div class="box-des">
                       <img onclick="return false" class="box-des-img" src="../../assets/为您提供专业的软件定制开发服务.png" alt="">
                   </div>
                    <img  onclick="return false" class="carouselBg" src="../../assets/carouselBg.png" alt="">
                </div>
                <div  key="En" v-if="isEn" class="box" :class="{boxEn:isEn}">
                    <div class="box-des">
                        <img onclick="return false" class="box-des-img" src="../../assets/carouselBgEn.png" alt="">
                    </div>
                    <img  onclick="return false" class="carouselBg" src="../../assets/carouselBg.png" alt="">
                </div>

            </transition>
        </div>
    </div>
</template>

<script>
    import Carousel from '../../components/carousel/carousel'
    import carouselItem from '../../components/carousel/carousel-item'
    export default {
        name: "carousel",
        components:{
            'x-carousel': Carousel,
            'x-carousel-item': carouselItem,
        },
        mounted() {
            this.repairIntroduce()
            setTimeout(() =>{
                this.$refs.carousel&&this.$refs.carousel.classList.add('active')
            }, 500)
        },
        data(){
            return {
                carouselAutoPlay: false,
                selected: '1',
                cursorBlink: true,
                isEn:false,
            }
        },
        methods:{
            repairIntroduce(){
                if(this.$i18n.locale==='en'){
                    this.isEn = true
                }
            },
        },
        watch:{
            '$i18n.locale'(){
                if(this.$i18n.locale==='zh'){
                    this.isEn = false
                }else{
                    this.isEn = true
                }
            }
        }
    }
</script>

<style scoped lang="scss" src="./carousel.scss"></style>
